export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12667.63f2ff63.jpg";